import { useTranslation } from 'react-i18next';

export default function useBrandInfo() {
  const { t } = useTranslation();

  return {
    CLIENT_NAME: t('Brand'),
    CLIENT_NAME_FOOTER: t('Brand Footer'),
    CLIENT_DESCRIPTION: t('Brand Description'),
    CLIENT_MEDIA: t('Brand Media'),
  };
}
